<template>
  <!--Start Page Banner-->
  <div class="page-banner-area bg-1">
    <div class="container">
      <div class="page-banner-content">
        <h1>DVV</h1>
        <ul>
          <li><a href="/">Home</a></li>
          <li>NAAC</li>
          <li>SSR Documents</li>
          <li>DVV</li>
        </ul>
      </div>
    </div>
  </div>
  <!--End Page Banner-->

  <!-- Start EI area -->
  <div class="alumni-area pt-100 pb-70">
    <div class="container">
      <div class="row">
        <div class="curriculum">
          <h3>Criteria 1</h3>
          <div class="curriculum-list">
            <ul>
              <li>
                1.2.1<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/16_DVV/01_criteria_1/1.2.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                1.2.2<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/16_DVV/01_criteria_1/1.2.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>              
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="curriculum">
          <h3>Criteria 5</h3>
          <div class="curriculum-list">
            <ul>
              <li>
                5.1.1<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/16_DVV/05_criteria_5/5.1.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                5.1.2<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/16_DVV/05_criteria_5/5.1.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                5.1.3<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/16_DVV/05_criteria_5/5.1.3.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                5.3.2
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/16_DVV/05_criteria_5/5.3.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>                            
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="curriculum">
          <h3>Criteria 6</h3>
          <div class="curriculum-list">
            <ul>
              <li>
                6.5.2<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/16_DVV/06_criteria_6/6.5.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>              
            </ul>
          </div>
        </div>
      </div>      
    </div>
  </div>
  <!-- End EI area -->

  <!-- Start Bottom Connect Area -->
  <div class="alumni-interview-area pb-100">
    <div class="container">
      <div class="interview-content ptb-100">
        <div class="interview">
          <a href="/newsletter" class="default-btn btn"
            >Newsletter<i class="flaticon-next"></i
          ></a>
          <router-link to="/applynow" class="default-btn btn"
            >Apply Now</router-link
          >
        </div>
      </div>
    </div>
  </div>
  <!--End Bottom Connect Area -->
</template>

<script>
export default {
  name: "ssrd-criteria2",
};
</script>
